import {useIntl} from 'react-intl';
import ForecastTooltip from '../../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import InformationIcon from '../../../../images/information-icon';
import InputField from '../../../../components/new-ui/input_field';
import Button from '../../../../forecast-app/shared/components/buttons/button/button';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../../../constants';
import InlineLoader from '../../../../forecast-app/shared/components/inline-loader/inline_loader';
import React from 'react';

import {CheckmarkIcon, WarningIcon} from 'web-components';
export const JiraTempoTokenSection = ({
	tempoTokenApplied,
	showTokenValidMarkingSubmit,
	submitTempoToken,
	submittingTempoToken,
	verifyTempoToken,
	verifyingTempoToken,
	submittedTempoTokenValid,
	showTokenValidMarkingVerify,
	tempoTokenValid,
	tempoToken,
	setTempoToken,
}) => {
	const {formatMessage} = useIntl();
	return (
		<div className="settings-app-jira-section live">
			<span className="settings-app-jira-section-title standard">Tempo Timesheets</span>
			<div className="settings-app-jira-section-body">
				<div className="current-settings">
					<div className="settings-title-container">
						<div className="current-settings-title">Token</div>
						<ForecastTooltip content={formatMessage({id: 'app_jira.integrate_page.tempo.token.tooltip'})} delay={0}>
							<InformationIcon />
						</ForecastTooltip>
					</div>
					{tempoTokenApplied && (
						<div className="settings-title-container">
							<div className="current-settings-title" style={{color: '#7CD99F'}}>
								{formatMessage({id: 'app_jira.integrate_page.tempo.token.applied'})}
							</div>
							<CheckmarkIcon size={CheckmarkIcon.SIZE.SMALL} />
						</div>
					)}
					<InputField hideLabel onChange={setTempoToken} />
					<div style={{display: 'flex', columnGap: '12px'}}>
						<Button
							className="settings-button"
							buttonStyle={BUTTON_STYLE.OUTLINE}
							colorTheme={BUTTON_COLOR.WHITE}
							isDisabled={!tempoToken}
							text={formatMessage({id: 'common.submit'})}
							onClick={submitTempoToken}
						/>
						{showTokenValidMarkingSubmit && (
							<>
								{submittingTempoToken ? (
									<InlineLoader />
								) : submittedTempoTokenValid ? (
									<CheckmarkIcon />
								) : (
									<WarningIcon updated color={'#E01212'} />
								)}
							</>
						)}
					</div>
					<div className="settings-title-container" style={{paddingTop: '8px'}}>
						<div className="current-settings-title">
							{formatMessage({id: 'app_jira.integrate_page.tempo.token_check.title'})}
						</div>
						<ForecastTooltip
							content={formatMessage({id: 'app_jira.integrate_page.tempo.token_check.tooltip'})}
							delay={0}
						>
							<InformationIcon />
						</ForecastTooltip>
					</div>
					<div style={{display: 'flex', columnGap: '12px'}}>
						<Button
							className="settings-button"
							buttonStyle={BUTTON_STYLE.OUTLINE}
							colorTheme={BUTTON_COLOR.WHITE}
							isDisabled={!tempoTokenApplied}
							text="Check"
							onClick={verifyTempoToken}
						/>
						{showTokenValidMarkingVerify && (
							<>
								{verifyingTempoToken ? (
									<InlineLoader />
								) : tempoTokenValid ? (
									<CheckmarkIcon />
								) : (
									<WarningIcon updated color={'#E01212'} />
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
